import { NgModule } from '@angular/core';
import { SoftAuroraBackgroundComponent } from './soft-aurora-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        SoftAuroraBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        SoftAuroraBackgroundComponent
    ]
})
export class NcSoftAuroraBackgroundModule { }